import { TypographyP } from "@/components/typography/P";
import { TypographySM } from "@/components/typography/SM";
import { Button } from "@/components/ui/button";
import { Link } from "@tanstack/react-router";
import { ArrowRight, Building } from "lucide-react";

interface Props {
  organizationSlug: string;
}

const NoPaymentAccount = ({ organizationSlug }: Props) => {
  return (
    <div
      data-testid="no-payment-account-guide"
      className="row-start-2 rounded border dark:border-brand-gray-800 h-fit p-6 grid grid-cols-[35px_1fr] gap-y-3 items-center"
    >
      <Building
        className="h-6 w-6 dark:text-brand-gray-600"
        strokeWidth="1.6"
      />
      <TypographyP className="col-start-2">No payment account</TypographyP>
      <TypographySM className="col-start-2 row-start-2 dark:text-brand-gray-400">
        Your organization does not have a payment account. Please add a payment
        account to continue, this can be done on the organization settings page.
      </TypographySM>
      <Link
        to="/organization/$organizationSlug/organization-settings"
        params={{ organizationSlug }}
        className="col-start-2 row-start-3 place-self-end"
      >
        <Button variant="ghost">
          Organization settings
          <ArrowRight className="w-4 h-4 ml-2 inline" />
        </Button>
      </Link>
    </div>
  );
};

export default NoPaymentAccount;
